import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../components/dashboard/Sidebar';

export default function Profile() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [companyName, setCompanyName] = useState('');
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    axios.get('/auth/me').then(res => {
      setUser(res.data);
      setCompanyName(res.data.company_name);
    }).catch(() => {});
  }, []);

  const showAlert = (type, msg) => {
    setAlert({ type, msg });
    setTimeout(() => setAlert(null), 4000);
  };

  const handleReset = async () => {
    if (!window.confirm('Reset all sync data? This will clear all mappings, sync logs and gatekeeper items. Connected accounts will remain.')) return;
    try {
      await axios.delete('/api/dashboard/reset');
      alert('Sync data reset successfully');
    } catch (err) {
      alert('Reset failed: ' + err.message);
    }
  };

  const handleSave = async () => {
    if (form.new_password && form.new_password !== form.confirm_password) {
      showAlert('error', 'New passwords do not match');
      return;
    }
    if (form.new_password && form.new_password.length < 8) {
      showAlert('error', 'New password must be at least 8 characters');
      return;
    }
    setSaving(true);
    try {
      await axios.patch('/auth/profile', {
        company_name: companyName,
        current_password: form.current_password || undefined,
        new_password: form.new_password || undefined
      });
      setForm({ current_password: '', new_password: '', confirm_password: '' });
      showAlert('success', 'Profile updated successfully');
    } catch (err) {
      showAlert('error', err.response?.data?.error || 'Update failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="app-main">
        <div className="page-header">
          <div>
            <h2 className="page-title">Profile</h2>
            <p className="page-sub">Manage your account details and password</p>
          </div>
        </div>

        {alert && (
          <div className={`alert alert-${alert.type}`} style={{ marginBottom: 20 }}>
            {alert.msg}
            <button onClick={() => setAlert(null)} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit' }}>✕</button>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 520 }}>
          {/* Account Info */}
          <div className="panel">
            <div className="card-header">
              <span className="card-title">Account Info</span>
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                value={user?.email || ''}
                disabled
                style={{ opacity: 0.6, cursor: 'not-allowed' }}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Company Name</label>
              <input
                className="form-input"
                value={companyName}
                onChange={e => setCompanyName(e.target.value)}
                placeholder="Acme Construction"
              />
            </div>
          </div>

          <div className="divider" />

          {/* Change Password */}
          <div className="panel">
            <div className="card-header">
              <span className="card-title">Change Password</span>
            </div>
            <div className="form-group">
              <label className="form-label">Current Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={form.current_password}
                onChange={e => setForm({ ...form, current_password: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={form.new_password}
                onChange={e => setForm({ ...form, new_password: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={form.confirm_password}
                onChange={e => setForm({ ...form, confirm_password: e.target.value })}
              />
            </div>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 16 }}>
              Leave password fields blank to update company name only.
            </p>
          </div>

          <button className="btn btn-primary" onClick={handleSave} disabled={saving} style={{ alignSelf: 'flex-start' }}>
            {saving ? <><div className="spinner" style={{ width: 13, height: 13 }} /> Saving...</> : 'Save Changes'}
          </button>

          <div className="card card-glass" style={{ marginTop: 24, borderColor: 'rgba(255,80,80,0.2)' }}>
            <div className="card-header">
              <span className="card-title" style={{ color: 'var(--danger)' }}>Danger Zone</span>
            </div>
            <div className="card-body">
              <p style={{ color: 'var(--muted2)', fontSize: 13, marginBottom: 16 }}>
                Reset all sync data including mappings, sync logs, and gatekeeper items. Your connected accounts will remain intact.
              </p>
              <button className="btn btn-danger" onClick={handleReset}>↺ Reset Sync Data</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
